module.exports = __webpack_public_path__ + "img/lottery-answer-success.5e642f40.jpg";